export interface Environment {
  readonly language: string;
  readonly artifactId: string;
  readonly componentId?: string;
  readonly componentName?: string;
  readonly uiLibVersion?: string;
  readonly providerType?: 'bm' | 'giza' | 'essentials';
  readonly msid?: string;
}

export interface EnvironmentBi {
  readonly artifactId?: string;
  readonly componentId?: string;
}
